export const MAIN_COLOR_BLUE ="#3070b3"
